
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import coinImg from '@/assets/images/coin.png'
import bgImg from "@/assets/images/pk/bg.png"
import people from "@/assets/images/pk/people.png"
import times from "@/assets/images/pk/times.png"
import pk from "@/assets/images/pk/pk.png"
import selected from "@/assets/images/pk/selected.png"
import unknow from "../../assets/images/pk/unknow.png"
import unknownnoneImg from "../../assets/images/pk/unknow-none.png"
import unknowone from "../../assets/images/pk/unknow-one.png"
import tipImg from "@/assets/images/attribute/tip.svg"
import battleImg from "@/assets/images/tabbar/battle.png"
import coinsImg from '@/assets/images/task/coins.png'
import CreateArena from "./createArena"
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux';
import { getApexRank, getBattleArenasList, delBattleArenas, getBattleArenasDetail, getBattleDeck, pkCheck, getDeckReward, postAuto_pk } from '@/api/pk_url.js'
import { getUserInfo, getBattleCards, postSetting, getSetting, } from '@/api/url.js'
import Back from '../../components/common/BackComp';
import ButtonComp from '../../components/common/ButtonComp';
import { coinMovementOffset, formatNumber, FormattingNumber, FormattingTwoNumber } from '../../utils'
import PromptDialog from '../../components/PromptDialog'
import CardItem from '../../components/CardItem'
import { changeUserInfo } from '../../store/module/tabbar'

import { List } from 'react-vant'
import coin from '@/assets/images/coin.png'
import coinsMusic from "@/assets/mp3/coins.mp3"
import DrawCardsDialog from "../../components/DrawCardsDialog"
import NFTDrawCardsDialog from "../../components/NFTDrawCardsDialog"
import ruleText from '../../text/rulesText1.tsx'
import { PK_CARDS, ARENA_LIST } from '../../constants/common-constants.js';
import RulesDialog from '../../components/RulesDialog'
import { changeBattleCardData } from '../../store/module/card'
import PublicDialog from '../../components/PublicDialog'
import { changeSettings } from '../../store/module/settins.js'
import { postWarningInformation } from "@/api/url.js"
import { changeArenaNavActive } from '../../store/module/battle.js'
import BlurDialog from '../../components/BlurDilaog.js'
import NsfwPay from '../../components/nsfw/nsfwPay.js'
import { useTranslation } from 'react-i18next'
import BattleGuide from '../../components/guide/BattleGuide.tsx'
import { changeLoginState } from '../../store/module/h5Login.js'
const width = window.innerWidth;
const height = window.innerHeight;


const Battle = () => {
	const { t } = useTranslation();
	const PK_RULES = ruleText().PK_RULES
	const [currArenaId, setCurrArenaId] = useState<number>(-1)
	const [isShowOther, setShowOther] = useState(false)
	const [isShowCreateArenaBtn, setShowCreateArenaBtn] = useState(false)
	const [isCreate, setCreate] = useState(false)
	const [promptText, setPromptText] = useState('')
	const [isStart, setStart] = useState(false)
	const userInfo = useSelector((state: any) => state.tabbar.userInfo)
	const [isCancel, setCancel] = useState(false)
	const [isShowMenuList, setShowMenuList] = useState(false)
	const [isShowCreateArena, setCreateArena] = useState(false)
	const [rulesDialog, setRulesDialog] = useState(false)
	const [autoPKDialog, setAutoPKDialog] = useState(false)
	const [auto_pkDeck, setAuto_pkDeck] = useState<any>({})
	const [selectCard, setSelectCard] = useState(false)
	const deckLength = useRef(0)
	const [dataList, setDataList] = useState<any>([])
	const guideTypeList = useSelector((state: any) => state.progress.guideTypeList)
	const [level, setLevel] = useState<any>(0)
	const currPage = useRef(1)
	const currPageCard = useRef(1)
	const total = useRef(0);
	const totalCard = useRef(0);
	const pageSize = 10
	const [finished, setFinished] = useState(false);
	const [finishedCard, setFinishedCard] = useState(false);
	const [cardArr, setCardArr] = useState<any>([]);
	const isInitLoading = useRef(true)
	const isInitLoadingCard = useRef(true)
	const [isLoading, setIsLoading] = useState(false)
	const [isLoadingCard, setIsLoadingCard] = useState(false)
	const { arenaNavActive } = useSelector((state: any) => state.battle)
	const [isActive, setActive] = useState(arenaNavActive)
	const settings = useSelector((state: any) => state.settings.settings)
	const guideType = useSelector((state: any) => state.tabbar.guideType)
	const [isShowPresent, setShowPresent] = useState(false)
	const [coin_NSFW, setCoin_NSFW] = useState(false)
	const [nsfwType, setNsfwType] = useState<number>(-1)
	const [starType, setStateType] = useState<any>("")
	const dataStatistics = useSelector((state: any) => state.progress.dataStatistics)
	const clickHandle = useCallback((e: Event) => {
		e.stopPropagation();
		if (isShowMenuList) {
			setShowMenuList(false)
		}
	}, [])


	useEffect(() => {
		currPage.current = 1
		setDataList([])
		currPageCard.current = 1
		setCardArr([])
		if (!isShowCreateArena) {
			getBattleArenasDetailHandle()
			getBattleArenasListHandle()
			setUserInfo()
		}

	}, [isShowCreateArena, isActive])

	useMemo(() => {
		let list = dataList.filter((item: any) => item.is_my)
		if (list.length) {
			setCurrArenaId(list[0].id)
		} else {
			setCurrArenaId(-1)
		}

	}, [dataList])


	useEffect(() => {
		document.addEventListener("click", clickHandle)
		return () => {
			document.removeEventListener("click", clickHandle)
		}
	}, [isShowMenuList])
	const dispatch = useDispatch()
	const navigate = useNavigate();
	const isSoundPlay = useSelector((state: any) => state.settings.settings.sound)
	const AudioRef = useRef<any>()
	const boxRef = useRef<any>(null)
	const [isFirst, setFirst] = useState(true)
	const isLock = useRef(false)

	useEffect(() => {
		setActive(arenaNavActive)
	}, [])
	const getCoinAnimation = (x: any, y: any) => {
		const R = 100; // 扩散半径
		const time = 0.25; //扩散过度时间
		const time2 = 1; // 收集过度时间
		const w = 26; // 金币大小
		const Num = 8 //金币数量

		const screenWidth = window.innerWidth;
		const pcX = screenWidth > 768 ? screenWidth > 1536 ? (screenWidth / 2) - 220 : screenWidth > 1920 ? (screenWidth / 2) - 250 : (screenWidth / 2) - 187.5 : 0
		setlits((x - pcX), y)

		if (AudioRef.current) {
			// AudioRef.current.currentTime = 0;
			AudioRef.current.play()
		}
		const total = document.getElementsByClassName('total_1')[0] // 获取金币最终飞向

		function setlits(X: any, Y: any) {
			var species = document.createElement('div');
			species.className = 'species'
			for (let i = 0; i < Num; i++) {
				var img = document.createElement('img');
				img.className = 'speciesstyle'
				img.style.width = w + 'px',
					img.style.height = w + 'px',
					img.style.left = X + 'px',
					img.style.top = Y + 'px',
					img.style.transform = 'translate(0%, 0%)',
					img.style.transition = `${time}s`
				img.src = coin
				species.appendChild(img);
			}
			boxRef.current.appendChild(species)
			setTimeout(() => {
				clickss(X, Y)
			}, 0)
		}
		// 计算金币扩散范围和坐标
		function clickss(X: number, Y: number) {
			const specielist: any = document.getElementsByClassName('speciesstyle')
			const num = specielist.length
			const center = {
				x: X,
				y: Y
			}
			for (let i = 0; i < num; i++) {
				const xz = center.x + Math.floor(Math.random() * ((R * 1.1) - (R * 0.6) + 1)) + (0.6 * R) * Math.sin(2 * Math.PI * i / num)
				const yz = center.y + Math.floor(Math.random() * ((R * 1.1) - (R * 0.6) + 1)) + (0.6 * R) * Math.cos(2 * Math.PI * i / num)
				specielist[i].style.transform = `translate(${xz - (X + w / 2)}px, ${yz - (Y + w / 2)}px)`
			}
			setTimeout(() => {
				for (let i = 0; i < num; i++) {
					specielist[i].style.transition = `${time2}s`
					specielist[i].style.transform = `translate(0,0)`
					specielist[i].style.left = Math.floor(total?.getBoundingClientRect().x) - pcX + 'px'
					specielist[i].style.top = Math.floor(total?.getBoundingClientRect().y) + 'px'
				}
				// 结束清除蒙层
				setTimeout(() => {
					remove()
				}, (Number(time2) + 0.5) * 500) //飞行时间结束

			}, (Number(time) + 0.5) * 500) //扩散时间结束
		}
		// 清除dom
		function remove() {
			document.getElementsByClassName('species')[0].remove()
		}
	}

	const goToPage = (path: string) => {
		navigate(path);
	}
	const closeDrawCard = (val: any) => {
		dispatch(changeUserInfo({ ...userInfo, card_rewards: [], coins: 0 }))
	}

	const getBattleArenasDetailHandle = useCallback(async () => {
		setShowCreateArenaBtn(false)
		const { code, data } = await getBattleArenasDetail(0, isActive)
		if (code == "0") {
			if (data && Object.prototype.toString.call(data.cards) != '[object Null]') {
				setShowCreateArenaBtn(false)
			} else {
				setShowCreateArenaBtn(true)
			}
			setFirst(data?.is_first)

		} else {
			setShowCreateArenaBtn(true)
		}

	}, [isActive])

	const onLoad = async () => {
		if (finished || isInitLoading.current) return;
		currPage.current++
		await getBattleArenasListHandle();


	}

	const onLoadCard = async () => {
		if (finishedCard || isInitLoadingCard.current) return;

		currPageCard.current++
		await getBattleArenasListHandleCard();


	}

	const getDeckListHandle = async (count: number, text: string, callback: () => void) => {
		try {
			const { code, data } = await getBattleDeck(isActive)
			let list: any = []
			if (code === "0") {

				for (let i in data) {
					if (Object.prototype.toString.call(data[i]) === '[object Object]') {
						list.push(i)
					}
				}
				if (list.length >= count) {
					callback && callback()

				} else {
					setPromptText(text)
					setCreate(true)
				}

			} else {
				setPromptText(text)
				setCreate(true)

			}
		} catch (e) {
			setPromptText(text)
			setCreate(true)
		}

	}

	//获取擂台列表
	const getBattleArenasListHandle = useCallback(async () => {
		setIsLoading(true)
		try {
			const params = {
				limit: pageSize,
				page: currPage.current,
				type: arenaNavActive
			}
			const { code, data } = await getBattleArenasList(params)

			if (code == "0") {
				setIsLoading(false)
				total.current = data.count
				isInitLoading.current = false
				setFinished(false)
				if (!data?.arenas.length) {
					setShowOther(true)
				} else {
					setShowOther(false)
				}
				setDataList((prevData: any) => [...prevData, ...data.arenas]);
			} else {
				setShowOther(true)
				setFinished(true)
				total.current = 0
			}
		} catch (e) {
			setShowOther(true)
			setFinished(true)
			setIsLoading(false)
			total.current = 0
		}

		if (currPage.current * pageSize >= total.current) {
			setFinished(true)
			return false;
		}
	}, [isActive])

	//获取擂台列表
	const getBattleArenasListHandleCard = async (lv?: any) => {
		setIsLoadingCard(true)
		try {
			const parent = {
				limit: pageSize,
				page: currPageCard.current,
				level: lv ? lv : level,
			}
			const { code, data } = await getBattleCards(parent)
			if (code == "0") {
				if (data.count == 0) {
					setSelectCard(false)
					setPromptText(t("pk.you_do_not"))
					setCreate(true)
				}
				setIsLoadingCard(false)
				totalCard.current = data.count
				isInitLoadingCard.current = false
				setFinishedCard(false)
				setCardArr((cardArr: any) => [...cardArr, ...data.data]);
			} else {
				setFinishedCard(true)
				totalCard.current = 0
			}
		} catch (e) {
			setFinishedCard(true)
			setSelectCard(false)
			setPromptText(t("other.neterror"))
			setCreate(true)
			setIsLoadingCard(false)
			totalCard.current = 0
		}
		if (currPageCard.current * pageSize >= totalCard.current) {
			setFinishedCard(true)
			return false;
		}
	}


	//下架擂台
	const delBattleArenasHandle = async (id: number) => {
		try {
			const { code, data } = await delBattleArenas(id)
			if (code == "0") {
				currPage.current = 1
				setFinished(true)
				setDataList([])
				await getBattleArenasDetailHandle()
				await getBattleArenasListHandle()
				await setUserInfo()
			}

		} catch (e) {

		}

	}

	const setUserInfo = useCallback(async () => {
		const UserInfo = await getUserInfo()
		if (UserInfo.code == "0") {
			dispatch(changeUserInfo(UserInfo.data))

		}
	}, [])

	const [apexData, getApexDat] = useState<any>({})
	const apexRank = async () => {
		try {
			const { data, code } = await getApexRank(0, 10, 1)
			if (code == '0') {
				getApexDat(data)

			}
		} catch (e) {
			console.error('ApexRank error:', e)
		}

	}
	useEffect(() => {
		apexRank()
	}, [])
	const [activeCard, setActiveCard] = useState<any>({})
	const selectCardDialog = () => {
		return (
			<div className='px-[14px] pt-[42px]'>
				<p className='text-[#333] text-center text-[14px] leading-[18px]'>{t("pk.you_need_to")}</p>
				<p className='text-[16px] mt-3 leading-[19px] text-[#333]'>{t("pk.select_card")}:</p>

				<div style={{ overflowY: "scroll", height: "300px" }} className='mt-3 overflow-y-scroll overflow-x-hidden'>

					<List className='w-full text-center grid grid-cols-3 gap-3' finished={finishedCard} loading={isLoadingCard} immediateCheck={false} onLoad={onLoadCard} loadingText={t("other.loading")}>
						{cardArr.map((el: any) =>
							<div key={el.id} onClick={() => {
								setActiveCard(el)
							}} className='relative'>
								{activeCard.id === el.id && <div className='z-10 absolute flex justify-center items-center w-full h-full bg-[#fff]/50'>
									<img className='w-[70px]' src={selected} alt="" />
								</div>}
								<CardItem power={el?.power} property={el?.property} is_nft={el?.is_nft} height={0} mint_state={el?.mint_state} enhanceLevel={el?.enhance_level} image={el?.image} big={false} text={el?.description} level={el?.level + 1}>
								</CardItem>
							</div>
						)}
					</List>
				</div>
				<div>
					<p className='text-[12px] text-[#a6a6a6] text-center leading-4'>{t("pk.you_can_scroll")}</p>
					{Object.keys(activeCard).length > 0 &&
						<ButtonComp mt={8} width={174} height={40} title={t("other.ok")} callBack={() => {
							navigate(`/battle-result?id=${activeCard.id}`)
						}}>
						</ButtonComp>}
				</div>
			</div>
		)
	}
	const autoPKContent = () => {
		return (
			<div className='px-[10px] pt-[30px]'>
				<div className='flex justify-center'>
					<img className='w-[50px] h-[50px]' src={pk} alt="" />
				</div>
				<p className=' text-[14px] leading-[18px] text-center mt-[14px] text-[#333]'>{t("other.match")}</p>
				<div className='flex h-[30px] mt-[21px] mb-[30px] items-center'>
					<div className="loader-wrapper">
						<div className="packman"></div>
						<div className="dots">
							<div className="dot"></div>
							<div className="dot"></div>
							<div className="dot"></div>
							<div className="dot"></div>
						</div>
					</div>
				</div>
				<ButtonComp mt={8} width={174} height={40} title={t("card.main.cancel")} callBack={() => {
					setAutoPKDialog(false)
				}}>
				</ButtonComp>
			</div>
		)
	}

	return (
		<div ref={boxRef} className="role-box descriptionLogs w-full h-full text-white pt-[100px] px-4 box-border relative max-md:pb-[117px]">
			<div className="h-11 flex items-center justify-center md:absolute fixed top-0 w-[calc(100%)] -ml-4 px-4 z-[889] box-border bg-[#071919]">
				<Back isLeft={false} isMl={false} title={t("pk.arena_pk")} callback={() => {
					navigate('/pk')
				}}>
					<div className='w-[100vw] md:w-[375px] pl-[30px] text-white flex justify-center items-center'>
						{t("pk.arena_pk")}
					</div>
					{/* <div className='w-[100vh] -z-40 h-10 opacity-0 text-white flex justify-around items-center'>
						{
							ARENA_LIST().map(item => {
								return (
									<div onClick={() => {
										if (settings.vibration) {

										}
										if (!isLoading) {

											total.current = 0
											isInitLoading.current = true;
											setFinished(true)
											dispatch(changeArenaNavActive(item.id))
											setActive(item.id)

											// sessionStorage.setItem('avatarListId', item.id.toString())
										}
									}} key={item.id} className={`${item.id == isActive ? 'text-sm bg-gradient-to-r from-[#00E49F] to-[#54ADFF] !w-[110px]' : ''} text-white h-[32px] flex justify-center items-center w-[60px] py-1 rounded-3xl relative`}>
										<div className={`${item.id == isActive ? '!w-[108px]' : ''} absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] h-[30px] w-[58px] text-sm rounded-3xl bg-[#071919]`}></div>
										<p className={`${item.id == isActive ? '!w-[108px] text-center text-transparent bg-clip-text bg-gradient-to-r from-[#00E49F] to-[#54ADFF]' : ''} absolute`}>{item.name} {item.id == isActive && <span className={`${total.current != 0 ? '' : 'hidden'} text-transparent bg-clip-text text-sm bg-gradient-to-r from-[#00E49F] to-[#54ADFF]`}>{FormattingNumber(total.current.toString())}</span>} </p>
									</div>
								)
							})
						}
					</div> */}
					<div className={`text-white ml-3 ${localStorage.getItem('token') ? '' : 'hidden'}`} onClick={(e) => {
						e.stopPropagation()
						setShowMenuList(!isShowMenuList)
					}}>
						<svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

							<g id="页面-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
								<g id="人物聊天三个按钮" transform="translate(-341.000000, -56.000000)" fill="#FFFFFF" fillRule="nonzero">
									<g id="编组" transform="translate(341.000000, 56.000000)">
										<path d="M17.2208518,1.78487866 L1.63820742,1.78487866 C1.24863332,1.78487866 0.859059226,1.33865246 0.859059226,0.892426255 C0.859059226,0.446200055 1.24863332,0 1.63820742,0 L17.2208518,0 C17.6104259,0 18,0.4462262 18,0.892426255 C18,1.33862631 17.6104259,1.78487866 17.2208518,1.78487866 L17.2208518,1.78487866 Z M17.3939958,9.59366722 L5.27416133,9.59366722 C4.97115925,9.59366722 4.66815718,9.14746716 4.66815718,8.70124096 C4.66815718,8.25501476 4.97115925,7.80881471 5.27416133,7.80881471 L17.3939958,7.80881471 C17.6969979,7.80881471 18,8.25501476 18,8.70124096 C18,9.14746716 17.6969979,9.59366722 17.3939958,9.59366722 Z M17.3939958,17.4024819 L5.27416133,17.4024819 C4.97115925,17.4024819 4.66815718,16.9562557 4.66815718,16.5100557 C4.66815718,16.0638556 4.97115925,15.6176033 5.27416133,15.6176033 L17.3939958,15.6176033 C17.6969979,15.6176033 18,16.0638295 18,16.5100557 C18,16.9562819 17.6969979,17.4024819 17.3939958,17.4024819 Z M1.81133371,17.4024819 L0.691867913,18 L0.905666857,16.7344364 L-5.41860487e-14,15.8381593 L1.25160081,15.6535161 L1.81133371,14.5020683 L2.37106661,15.6535161 L3.62266743,15.8381593 L2.71700057,16.7344364 L2.93079951,18 L1.81133371,17.4024819 Z M1.81133371,9.66804551 L0.691867913,10.2655636 L0.905666857,9 L-5.41860487e-14,8.10372289 L1.25160081,7.91907965 L1.81133371,6.76763186 L2.37106661,7.91907965 L3.62266743,8.10372289 L2.71700057,9 L2.93079951,10.2655636 L1.81133371,9.66804551 Z" id="形状"></path>
									</g>
								</g>
							</g>
						</svg>
					</div>
				</Back>
				<div className='w-[calc(100vw_-_32px)] md:w-[calc(100%_-_32px)] ml-[16px] bg-[#32726e] grid grid-cols-4 rounded-[10px] h-9 md:absolute fixed top-[54px] left-0 z-[20] text-white'>
					{
						ARENA_LIST().map(item => {
							return (
								<div onClick={() => {
									if (settings.vibration) {

									}
									if (!isLoading) {

										total.current = 0
										isInitLoading.current = true;
										setFinished(true)
										dispatch(changeArenaNavActive(item.id))
										setActive(item.id)

										// sessionStorage.setItem('avatarListId', item.id.toString())
									}
								}} key={item.id}
									className={`${item.id == isActive ? 'bg-gradient-to-r from-[#00E49F] to-[#54ADFF]' : ''} text-white flex justify-center items-center rounded-[10px] relative h-9 `}>
									<p className='text-[12px] flex items-center'>{item.name}&nbsp;&nbsp;
										{!isLoading && item.id == isActive &&
											<span className={`${total.current != 0 ? '' : 'hidden'} text-[12px]`}>
												{FormattingNumber(total.current.toString())}
											</span>
										}
										<>
											{item.id == isActive && isLoading &&
												<svg className={`ml-[6px]  animate-spin `} width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
													<defs>
														<linearGradient x1="-2.72351586e-14%" y1="-1.94289029e-13%" x2="100%" y2="100%" id="linearGradient-1">
															<stop stopColor={'#fff'} offset="0%"></stop>
															<stop stopColor={'#fff'} offset="100%"></stop>
														</linearGradient>
													</defs>
													<g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
														<g id="10-cards-sale" transform="translate(-279.000000, -60.000000)" fill="url(#linearGradient-1)" fillRule="nonzero">
															<g id="编组" transform="translate(279.000000, 60.000000)">
																<path d="M11.7148409,2.30618042 C11.4911427,2.21958428 11.2443829,2.34576723 11.1659732,2.58576224 L10.8338852,3.58532915 C10.444143,2.64266829 9.8283965,1.8138195 9.04429979,1.19280144 C6.55133349,-0.786538945 2.99983662,-0.247168689 1.13184152,2.40019909 C0.227824132,3.68182199 -0.154999551,5.26034596 0.0571677919,6.84381828 C0.269335135,8.43471312 1.05573801,9.84251898 2.26647558,10.8049732 C3.28118897,11.6090803 4.46886487,12 5.6473161,12 C7.3700227,12 9.06966762,11.1711512 10.1789338,9.60004977 C10.6701474,8.90480646 11.0045416,8.12791535 11.1775041,7.28669569 C11.2282397,7.03680397 11.0806451,6.7918606 10.8500284,6.73742873 C10.6194117,6.68299687 10.388795,6.83886993 10.3380593,7.08876165 C10.1927708,7.79885002 9.90911231,8.4569807 9.4940023,9.04336029 C7.90966572,11.2874375 4.89550572,11.7451599 2.7784446,10.0627206 C1.75220038,9.24871686 1.08802434,8.05863844 0.908143328,6.71268697 C0.728262313,5.37415803 1.05112567,4.04057745 1.81677305,2.95688857 C3.39880347,0.712811404 6.41065731,0.252614756 8.53002459,1.93505409 C9.29797813,2.54370126 9.87221366,3.38739511 10.1835462,4.33995266 L8.70529326,3.72140878 C8.48390124,3.62986429 8.23483523,3.74615054 8.14720089,3.98367139 C8.05956655,4.22119224 8.17026256,4.4884032 8.39165457,4.58242186 L10.568676,5.49539262 C10.6194117,5.5176602 10.6724535,5.5275569 10.7254954,5.5275569 C10.7324139,5.5275569 10.7393324,5.52508272 10.7462509,5.52508272 C10.762394,5.5275569 10.7785372,5.53497942 10.7946804,5.53497942 C10.9722552,5.53497942 11.1382992,5.416219 11.2005657,5.22818165 L11.9754378,2.90245669 C12.0538474,2.65751334 11.9385391,2.39277656 11.7148409,2.30618042 Z" id="路径"></path>
															</g>
														</g>
													</g>
												</svg>}
										</>
									</p>
								</div>
							)
						})
					}
				</div>


				<div className={`${isShowMenuList ? '' : 'hidden'} menu-list w-[180px] z-[1000] min-h-[146px] bg-[#333] absolute right-0 top-[46px] rounded-xl px-[10px] py-[20px] flex flex-col`}>
					<div className='flex items-center justify-between' onClick={(e) => {
						e.stopPropagation()
						setShowMenuList(!isShowMenuList)
						navigate("/pk-ranks")
					}}>
						<span className='text-white'>{t("pk.menu1")}</span>

						<svg width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
							<g id="页面-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
								<g id="卡牌战争1" transform="translate(-337.000000, -112.000000)">
									<g id="编组-6备份" transform="translate(337.000000, 112.000000)">
										<rect id="矩形备份-3" fill="#D8D8D8" opacity="0" x="0" y="0" width="22" height="22"></rect>
										<g id="编组" transform="translate(1.222222, 1.222222)" fill="#FFFFFF" fillRule="nonzero">
											<path d="M16.0275418,2.024 L16.0275418,1.19288889 C16.0275418,0.528 15.4509412,0 14.7668388,0 L4.77894386,0 C4.09484147,0 3.51824088,0.528 3.51824088,1.19288889 L3.51824088,2.024 C1.51479816,2.39555556 0,4.14577778 0,6.25777778 C0,8.50666667 1.72002887,10.3448889 3.90915653,10.5404444 C4.71053362,12.6133333 6.64556611,14.1386667 8.99106003,14.4222222 L8.99106003,17.9911111 L5.08190349,17.9911111 C4.86689988,17.9911111 4.67144206,18.0791111 4.52484869,18.216 C4.38802821,18.3626667 4.30007219,18.5582222 4.30007219,18.7733333 C4.30007219,19.2035556 4.65189627,19.5555556 5.08190349,19.5555556 L14.4638792,19.5555556 C14.8938864,19.5555556 15.2457105,19.2035556 15.2457105,18.7733333 C15.2457105,18.3431111 14.8938864,17.9911111 14.4638792,17.9911111 L10.5547226,17.9911111 L10.5547226,14.4222222 C11.9717919,14.256 13.2422678,13.6302222 14.2000111,12.7013333 C14.835249,12.0951111 15.3238936,11.3617778 15.646399,10.5404444 C17.8355267,10.3448889 19.5555556,8.49688889 19.5555556,6.25777778 C19.5457827,4.14577778 18.0309845,2.39555556 16.0275418,2.024 Z M1.56366261,6.25777778 C1.56366261,5.016 2.39435838,3.96977778 3.51824088,3.63733333 L3.51824088,8.448 C3.51824088,8.59466667 3.52801377,8.75111111 3.53778666,8.89777778 C2.39435838,8.55555556 1.56366261,7.49955556 1.56366261,6.25777778 Z M12.2845244,6.40444444 L11.4440557,7.27466667 C11.3463268,7.37244444 11.2974624,7.51911111 11.3267811,7.66577778 L11.5222389,8.86844444 C11.5808762,9.24 11.1899606,9.51377778 10.8674552,9.33777778 L9.89993892,8.8 C9.76311844,8.72177778 9.60675218,8.72177778 9.4699317,8.8 L8.50241546,9.33777778 C8.17991004,9.52355556 7.78899439,9.24 7.84763174,8.86844444 L8.04308957,7.66577778 C8.06263535,7.52888889 8.02354378,7.38222222 7.92581487,7.27466667 L7.08534622,6.40444444 C6.83125104,6.14044444 6.97784441,5.70044444 7.33944139,5.64177778 L8.46332389,5.46577778 C8.59037148,5.43644444 8.71741907,5.33866667 8.78582931,5.21155556 L9.27447387,4.16533333 C9.43084014,3.82311111 9.9194847,3.82311111 10.0856239,4.16533333 L10.5742684,5.21155556 C10.6329058,5.34844444 10.7599534,5.44622222 10.9065467,5.46577778 L12.0304292,5.64177778 C12.3920262,5.70044444 12.5386196,6.14044444 12.2845244,6.40444444 L12.2845244,6.40444444 Z M16.007996,8.888 C16.0177689,8.74133333 16.0275418,8.59466667 16.0275418,8.43822222 L16.0275418,3.63733333 C17.1514243,3.97955556 17.9821201,5.02577778 17.9821201,6.25777778 C17.9821201,7.49955556 17.1514243,8.55555556 16.007996,8.888 Z" id="形状"></path>
										</g>
									</g>
								</g>
							</g>
						</svg>
					</div>
					<div className='flex items-center justify-between mt-[20px]' onClick={(e) => {
						e.stopPropagation()
						setShowMenuList(!isShowMenuList)
						navigate("/pk-records")
					}}>
						<span className='text-white'>{t("pk.menu2")}</span>
						<svg width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
							<g id="页面-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
								<g id="卡牌战争1" transform="translate(-336.000000, -150.000000)">
									<g id="编组-68" transform="translate(336.000000, 150.000000)">
										<rect id="矩形" fillOpacity="0" fill="#D8D8D8" x="0" y="0" width="22" height="22"></rect>
										<g id="编组-29" transform="translate(1.000000, 2.000000)" fill="#FFFFFF">
											<g id="编组" fillRule="nonzero">
												<path d="M16.9172238,0 L12.8933802,1.56365958 L6.81655524,7.81694584 L9.93708699,10.9861789 L15.9731808,4.77480658 C16.3839961,4.35206189 16.671523,3.73236686 16.8357615,2.91572148 C16.9452538,2.32396905 17,1.66190941 17,0.929542552 L16.9178807,0 L16.9172238,0 Z M4.96854349,7.18282881 L3.73675465,8.45038684 L4.96854349,9.71794487 L0,14.8307669 L3.0798006,18 L8.04834409,12.9297679 L9.28013294,14.1973259 L10.5533099,12.9297679 L4.96920045,7.18350484 L4.96854349,7.18282881 Z" id="形状"></path>
											</g>
											<rect id="矩形" x="11" y="11" width="9" height="3"></rect>
											<rect id="矩形备份-110" x="15" y="7" width="5" height="3"></rect>
											<rect id="矩形备份-109" x="8" y="15" width="12" height="3"></rect>
										</g>
									</g>
								</g>
							</g>
						</svg>
					</div>

					<div className='flex items-center justify-between mt-[20px]' onClick={(e) => {
						e.stopPropagation()
						setShowMenuList(!isShowMenuList)
						setRulesDialog(true)

					}}>
						<span className='text-white'>{t("pk.menu3")}</span>
						<img className='h-[22px] w-[22px]' src={tipImg} alt="" />
					</div>
				</div>
			</div>


			<div className=" flex justify-center fixed z-[99] bg-[#071919] top-[90px] pt-[10px] left-0 md:w-[375px] lg:w-[444px]  xl:w-[500px] md:translate-x-[-50%] md:left-[50%] w-[100%] px-3 gap-6 items-center">
				<div className=" text-center">
					<p className="text-[14px] leading-[18px] mb-1 text-[#FFFFFF] font-bold">{t("pk.new_arenas")}</p>
					<div className="flex items-center">
						<p className="text-style-1 text-[16px] leading-[19px] font-bold">{dataStatistics?.pkArenasTotalDay ? formatNumber(dataStatistics?.pkArenasTotalDay) : '0'}</p>
					</div>
				</div>
				<div style={{ borderLeft: ' 1px dashed #00E49F' }} className=" w-[1px] h-[50px]"></div>
				<div className=" text-center">
					<p className="text-[14px] leading-[18px] mb-1 text-[#FFFFFF] font-bold">{t("pk.participants")}</p>
					<div className="flex items-center">
						<p className="text-style-1 text-[16px] leading-[19px] font-bold">{dataStatistics?.pkUserTotalDay ? formatNumber(dataStatistics?.pkUserTotalDay) : '0'}</p>
					</div>
				</div>
				<div style={{ borderLeft: ' 1px dashed #00E49F' }} className=" w-[1px] h-[50px]"></div>
				<div className=" text-center">
					<p className="text-[14px] leading-[18px] mb-1 text-[#FFFFFF] font-bold">{t("pk.PK_times")}</p>
					<div className="flex items-center">
						<p className="text-style-1 text-[16px] leading-[19px] font-bold">{dataStatistics?.pkTotalDay ? formatNumber(dataStatistics?.pkTotalDay) : '0'}</p>
					</div>
				</div>
			</div>
			<div className={`${dataList.length > 0 ? 'md:h-[100%]' : ''} pt-[10px] md:pb-[117px] md:overflow-y-auto`}>
				<List className='list w-full flex flex-wrap justify-between' finished={finished} loading={isLoading} immediateCheck={false} onLoad={onLoad} loadingText={t("other.loading")}>
					{

						dataList.length > 0 && dataList.map((item: any, i: number) => {
							return (
								<div key={item.id} style={{ background: item.is_my ? "linear-gradient( 135deg, #65A2FC 0%, #8BBDFC 45%, #609EFF 82%, #97BCFB 100%)" : "#123a38" }} className={`${item.is_my ? '' : 'special-class'} mb-4 p-[10px] h-[202px] w-full  rounded-[10px] flex flex-col`}>
									<div className='w-full flex justify-between'>
										<div className='text-white'>{t("pk.deck_info")}:</div>
										<div className='text-white flex'>
											{
												!item.is_my && !item.is_can_battle &&
												<svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
													<defs>
														<linearGradient x1="0%" y1="50%" x2="100%" y2="50%" id="linearGradient-1">
															<stop stopColor="#00E49F" offset="0%"></stop>
															<stop stopColor="#54ADFF" offset="100%"></stop>
														</linearGradient>
														<linearGradient x1="0%" y1="50%" x2="100%" y2="50%" id="linearGradient-2">
															<stop stopColor="#00E49F" offset="0%"></stop>
															<stop stopColor="#54ADFF" offset="100%"></stop>
														</linearGradient>
													</defs>
													<g id="页面-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
														<g id="PK页调整" transform="translate(-330.000000, -298.000000)" fillRule="nonzero">
															<g id="编组备份-102" transform="translate(330.000000, 298.000000)">
																<path d="M6.00702438,8.70736832 L6.00702438,5.4862937 C6.00702438,3.60502711 7.79587982,2.08003623 10.0026563,2.08003623 C12.2091376,2.08003623 13.997993,3.60502711 13.997993,5.4862937 C13.997993,5.50393668 13.9990151,6.6037102 14.0010592,8.78561425 L16.7354148,8.77185412 C16.7368054,6.59601899 16.7375007,5.50083219 16.7375007,5.4862937 C16.5893395,2.42020909 13.6305413,0 10.0309899,0 C6.43143852,0 3.47293548,2.42046069 3.32447907,5.4862937 L3.32447907,8.70736832" id="路径" fill="url(#linearGradient-1)"></path>
																<path d="M16.8608701,20 L3.16215099,20 C1.42022313,20 0.00649312319,18.7990791 0,17.3140938 L0,10.7451345 C0,9.2601492 1.40871259,8.05469939 3.15064046,8.04941564 L16.8493595,8.04941564 C18.5912874,8.05469939 20,9.2601492 20,10.7451345 L20,17.3138422 C19.9940972,18.7912793 18.5939437,19.9891809 16.8608701,20 Z M12.2035299,12.4774497 C12.2067765,11.5802186 11.465675,10.8062751 10.4338587,10.6298985 C9.40204238,10.4535219 8.36786494,10.9237756 7.96499616,11.7523179 C7.56212738,12.5811119 7.90301635,13.5369674 8.77870256,14.0343947 L8.77870256,16.418624 C8.78490054,16.9900238 9.33002774,17.4502132 10.0002951,17.4502132 C10.3262239,17.4554222 10.6410729,17.3493504 10.8747724,17.1556043 C11.1084719,16.9618581 11.2416305,16.6965139 11.2446137,16.418624 L11.2446137,14.0343947 C11.8502197,13.6852789 12.2102847,13.100659 12.2035299,12.4774497 L12.2035299,12.4774497 Z" id="形状" fill="url(#linearGradient-2)"></path>
															</g>
														</g>
													</g>
												</svg>
											}
										</div>
									</div>
									<div className="card mt-2 flex justify-between">
										<div className="card-item w-[72px] rounded-md overflow-hidden h-[102px] mr-[10px] relative flex justify-center items-center">
											{
												item?.character_card?.url ?
													<>
														<img className='w-full h-full' src={item?.character_card?.url} alt="" />
														<div className='flex z-[2] items-center absolute top-1 left-0 bg-[#a6a6a6]/40 px-1 rounded-full'>
															<svg width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

																<g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
																	<g id="02-talk平铺" transform="translate(-26.000000, -256.000000)" fill="#E0E0E0" fillRule="nonzero">
																		<g id="编组-12" transform="translate(16.000000, 213.000000)">
																			<g id="编组-11" transform="translate(10.000000, 41.000000)">
																				<g id="编组备份-14" transform="translate(0.000000, 2.000000)">
																					<path d="M8.21868721,0.0401908054 C9.22610184,-0.121578513 10.1720156,0.207559831 10.9376267,0.98125273 C11.715538,1.76770052 12.0884434,2.80395747 11.9822419,3.89092289 C11.8772403,4.96482233 11.3276324,6.02534468 10.4027189,6.96018472 C10.1447152,7.2211933 9.45110512,7.92582315 8.45569067,8.93812579 C8.00808417,9.39356865 7.53167724,9.87794334 7.05167028,10.3669844 L6.58486349,10.8417152 L6.3994608,11.0305498 C6.17760519,11.2564834 5.8221048,11.2564834 5.6002492,11.0305498 L3.98862579,9.38796894 L3.64812085,9.04203146 C2.9645117,8.34797578 2.28080177,7.65402686 1.59699106,6.96018472 C0.672077627,6.02534468 0.122769655,4.96513342 0.0177681253,3.89092289 C-0.0884334169,2.80395747 0.284171994,1.76770052 1.0623833,0.98125273 C1.82799442,0.207559831 2.77390816,-0.121267423 3.78132278,0.0401908054 C4.52893364,0.159962319 5.28734465,0.546031036 6.000155,1.16230993 C6.71326535,0.546342126 7.47137637,0.159962319 8.21898723,0.0401908054 L8.21868721,0.0401908054 Z" id="路径"></path>
																				</g>
																			</g>
																		</g>
																	</g>
																</g>
															</svg>
															<div className='ml-1 text-xs text-[#e0e0e0]'> {item?.character_card?.like_count && FormattingTwoNumber(item?.character_card?.like_count.toString()) || 0}</div>

														</div>
														{/* 交互 */}
														<div className='flex z-[2] items-center ml-3 absolute bottom-1 right-1 bg-[#a6a6a6]/40 px-1 rounded-full'>
															<svg width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

																<g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
																	<g id="02-talk平铺" transform="translate(-64.000000, -255.000000)" fill="#E0E0E0" fillRule="nonzero">
																		<g id="编组-12" transform="translate(16.000000, 213.000000)">
																			<g id="编组-11" transform="translate(10.000000, 41.000000)">
																				<g id="编组备份-13" transform="translate(38.000000, 1.000000)">
																					<path d="M11.5239457,3.42134657 C11.2161611,2.7466612 10.7767079,2.1399395 10.2312596,1.63662729 C9.68247157,1.12220127 9.04171997,0.715207345 8.34233458,0.436816014 C6.84395033,-0.145605338 5.18103645,-0.145605338 3.6826522,0.436816014 C2.97615232,0.712982518 2.32842877,1.12008551 1.77368555,1.63662729 C1.23594722,2.14222152 0.803473534,2.74870995 0.501041122,3.42134657 C0.178294404,4.10860716 0.00741922747,4.85707272 0,5.61600137 C0.00821477146,6.99708519 0.546071031,8.32262114 1.50312335,9.3204187 L1.77368555,11.6250562 C1.79898275,11.8381332 1.97951517,11.9989627 2.19456009,12 C2.26829417,12.0001518 2.34080535,11.9812032 2.40499735,11.9450059 L4.14862044,10.9451631 C5.52973447,11.3649235 7.01226158,11.3085725 8.35736582,10.7851883 C9.06386569,10.5090218 9.71158924,10.1019188 10.2663325,9.58537702 C10.7970641,9.08283239 11.2242718,8.48166296 11.5239457,7.81565538 C12.1586848,6.41934278 12.1586848,4.81765917 11.5239457,3.42134657 Z M3.40707958,6.27089836 C3.05011418,6.27089836 2.76073656,5.98216743 2.76073656,5.62599979 C2.76073656,5.26983215 3.0501142,4.98110124 3.4070796,4.98110124 C3.764045,4.98110124 4.0534227,5.26983216 4.0534227,5.6259998 C4.05359058,5.97450211 3.77623622,6.26009212 3.42712123,6.27089836 L3.40707958,6.27089836 Z M5.99245174,6.27089836 C5.63548634,6.27089836 5.34610872,5.98216743 5.34610872,5.62599979 C5.34610872,5.26983215 5.63548636,4.98110124 5.99245176,4.98110124 C6.34941716,4.98110124 6.63879486,5.26983216 6.63879486,5.6259998 C6.63896274,5.97450211 6.36160838,6.26009212 6.01249339,6.27089836 L5.99245174,6.27089836 Z M8.5778239,6.27089836 C8.2208585,6.27089836 7.93148088,5.98216743 7.93148088,5.62599979 C7.93148088,5.26983215 8.22085852,4.98110124 8.57782391,4.98110124 C8.93478931,4.98110124 9.22416697,5.26983216 9.22416697,5.6259998 C9.22426192,5.97639176 8.94393696,6.26274972 8.59285513,6.27089836 L8.5778239,6.27089836 Z" id="形状"></path>
																				</g>
																			</g>
																		</g>
																	</g>
																</g>
															</svg>
															<div className='ml-1 text-xs text-[#e0e0e0]'>{item?.character_card?.chat_count && FormattingTwoNumber((item?.character_card?.chat_count).toString()) || 0}</div>
														</div>
														{
															(!settings.star_nsfw) && item?.character_card?.is_nsfw && <BlurDialog callback={() => {
																if (settings.character_nsfw) {
																	const o = dataList.map((obj: any) => {
																		if (obj.id == dataList[i].id) {
																			return {
																				...obj,
																				character_card: {
																					...obj.character_card,
																					is_nsfw: !obj.character_card.is_nsfw
																				}
																			}

																		} else {
																			return obj
																		}
																	})

																	setDataList(o)
																} else {
																	setNsfwType(15)
																	setStateType({ character_nsfw: true })

																	setCoin_NSFW(true)
																}
															}} eyesIsSmall></BlurDialog>
														}

													</>
													:
													<>
														<img src={unknownnoneImg} alt="" />
														<span className='text-[#a6a6a6] text-xl absolute'>{t("other.none")}</span>
													</>


											}

										</div>
										{
											item?.cards && item?.cards?.length > 0 && item?.cards.map((it: any, j: number) => {
												return (
													<div className="card-item w-[72px] rounded-md overflow-hidden h-[102px] mr-[10px] relative">
														{/* <img className='w-full h-full' src={item.url} alt="" /> */}
														<CardItem is_enhance={true} height={102} width={72} rounded={10} property={it?.property} mine={1} image={it?.url} isShowLevel={false} level={0}>
														</CardItem>

														{
															(!settings.star_nsfw) && it.is_nsfw && <BlurDialog callback={() => {

																if (settings.nsfw) {
																	const o = dataList.map((obj: any) => {
																		if (obj.id == dataList[i].id) {
																			if (Object.prototype.toString.call(obj.cards) == '[object Array]') {
																				let o = obj.cards.map((item: any) => {
																					if (item.url == dataList[i].cards[j].url) {
																						let obj = {
																							...item,
																							is_nsfw: !item.is_nsfw
																						}
																						return obj
																					} else {
																						return item
																					}

																				})
																				return {
																					...obj,
																					cards: o
																				}
																			}
																		} else {
																			return obj
																		}
																	})


																	setDataList(o)
																} else {
																	setNsfwType(14)
																	setCoin_NSFW(true)
																	setStateType({ nsfw: true })
																}

															}} eyesIsSmall></BlurDialog>
														}


													</div>
												)
											})

										}

										{
											item?.cards?.length >= 0 && item?.cards?.length < 3 && Array(3 - Number(item?.cards.length)).fill(1).map((item, index) => {
												return (
													<div key={index} className="card-item w-[72px] rounded-md overflow-hidden h-[102px] mr-[10px]">
														<img className='w-full h-full' src={unknowone} alt="" />
													</div>
												)
											})
										}
										<div className='w-[110px] h-[102px] flex justify-center bg-cover' style={{ background: `url(${unknow})`, backgroundSize: "100% 100%" }}>
											<img style={{ boxShadow: "0px 0px 10px #fff" }} className='h-[102px] w-15' src={unknowone} alt="" />
										</div>
									</div >

									<div className='flex justify-between w-full h-10 mt-2'>
										<div className='border-r flex items-center justify-center pr-5'>
											<div className='text-white'>{t("pk.time")}</div>
											<div className='text-white ml-2'>{item.remaining_count}/{item.count}</div>
										</div>
										<div className={`flex-1 border-r flex justify-center  items-center`}>
											<div className='text-white'>{t("pk.bet")}</div>
											{
												item.reward_type != 0 ?
													<div className='w-5 h-[30px] mx-4 relative'>
														{
															item?.reward_card?.url ?

																<CardItem is_enhance={true} height={30} rounded={4} width={20} mine={1} image={item?.reward_card?.url} level={item?.reward_card?.level + 1}>

																</CardItem>
																:
																<img className='w-full h-full' src={unknowone} alt="" />
														}


													</div>
													:
													<div className="flex items-center ml-2 text-style-level  !text-base font-bold" >
														<img className="w-4 h-4 mx-2" src={coinImg} alt="" />{FormattingTwoNumber(item.reward_coins.toString())}
													</div>
											}
											{
												item.reward_type != 0 && item?.reward_card?.url && <span className='text-style-6'>
													{PK_CARDS().filter(el => el.id == (item?.reward_card?.level + 1))[0].name}
												</span>
											}

										</div>
										<div className='ml-5 flex justify-center items-center'>
											{

												!item.is_my ?
													<ButtonComp disabled={!item.is_can_battle} width={80} height={32} title={t("other.pk")} callBack={async () => {
														if (!localStorage.getItem('token')) {
															dispatch(changeLoginState(true))
															return
														}
														if (isLock.current) { return false }
														isLock.current = true
														setTimeout(() => {
															isLock.current = false
														}, 2000)

														await getDeckListHandle(3, t("other.cfg1"), async () => {
															setCardArr([])
															const { code, data, msg } = await pkCheck(item.id)
															if (code != 0) {
																setPromptText(msg)
																setCreate(true)
																return false
															}

															if (item.reward_type == 1) {
																currPageCard.current = 1
																setSelectCard(true)

																setLevel(item.reward_card.level + 1)
																getBattleArenasListHandleCard(item.reward_card.level + 1)
																dispatch(changeBattleCardData(item))
															} else {
																if (item.reward_coins < userInfo.balance) {
																	dispatch(changeBattleCardData(item))
																	navigate('/battle-result')
																} else {
																	setPromptText(t("talk.insuf"))
																	setCreate(true)
																}
															}
														})



													}}>
														<img className='h-5 w-5 mr-2' src={battleImg} alt="" />
													</ButtonComp>
													:
													<ButtonComp width={80} height={32} title={t("card.main.cancel")} callBack={() => { setCancel(true), setCurrArenaId(item.id) }}>

													</ButtonComp>
											}

										</div>
									</div>
								</div>
							)
						})

					}

				</List >
			</div >
			{
				isShowOther && !dataList.length && <div className='flex justify-center items-center mt-16 text-white'>
					<img className='w-full absolute top-5' src={bgImg} alt="" />
					<div className='px-16 text-center mt-[280px]'>
						<p className='text-white mt-4'>🎉 {t("pk.welcome")}</p>
						<p className='text-white mt-4'>🃏 {t("pk.setup_deck")}</p>
					</div>
				</div>
			}
			{/* create Arena   */}
			<div className={`fixed md:absolute md:w-[375px] lg:w-[440px] xl:w-[500px] bottom-[48px] flex z-10 justify-around items-center left-0 w-full px-10`}>
				<ButtonComp width={130} height={36} title='' callBack={async () => {
					setAutoPKDialog(true)
					const { data, code } = await postAuto_pk(isActive)
					if (code == '0' && data) {
						setTimeout(() => {
							setAuto_pkDeck(data)
							if (data.reward_card) {
								currPageCard.current = 1
								setLevel(data.reward_card.level + 1)
								getBattleArenasListHandleCard(data.reward_card.level + 1)
								dispatch(changeBattleCardData({ ...data.reward_card, id: data.arena_id }))
								setAutoPKDialog(false)
								setSelectCard(true)
							} else {
								setAutoPKDialog(false)
								dispatch(changeBattleCardData({ ...data.reward_card, id: data.arena_id }))
								navigate(`/battle-result?id=0`)
							}
						}, 1000)
					} else {
						setAutoPKDialog(false)
						setPromptText(t("pk.not_found"))
						setCreate(true)
					}
				}}>
					<div className=' text-[12px] text-white leading-[15px] font-bold flex justify-center items-center'>
						<svg width="14px" className=' w-[14] h-[14px] mr-1 ' height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
							<g id="页面-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
								<g id="PK页调整" transform="translate(-154.000000, -667.000000)">
									<g id="编组-10" transform="translate(101.000000, 656.000000)">
										<g id="编组-23备份" transform="translate(53.000000, 11.000000)">
											<rect id="矩形备份" fill="#D8D8D8" opacity="0" x="0" y="0" width="14" height="14"></rect>
											<g id="编组" transform="translate(1.400000, 1.400000)" fill="#FFFFFF" fillRule="nonzero">
												<polygon id="路径" points="7.51548743 5.6 10.7266649 2.53160437 11.2 0 8.90833406 0.529672006 6.22222222 3.98535469"></polygon>
												<polygon id="路径" points="7.8316297 6.65949596 8.37704918 6.11252864 9.13037608 6.86612806 8.56605593 7.43065236 10.0713597 8.93650066 10.4480231 8.55970095 11.2 9.31330037 9.31803279 11.1959484 8.56605593 10.442349 8.94271938 10.0668998 7.43606557 8.55970095 6.87174542 9.12557579 6.11976856 8.37197637 6.7002893 7.79124563 5.63510125 6.86477752 4.5388621 7.83041119 5.08563163 8.37602798 4.33230473 9.1296274 3.76798457 8.5651031 2.26268081 10.0709514 2.63934426 10.4477511 1.88601736 11.2 0.00405014465 9.31735198 0.757377049 8.5651031 1.1340405 8.94055227 2.63934426 7.43470397 2.07367406 6.87017967 2.82700096 6.11793078 3.4075217 6.69731099 4.28640309 5.68846015 0.502217936 2.39315085 0 0 2.40038573 0.494296395"></polygon>
											</g>
										</g>
									</g>
								</g>
							</g>
						</svg>
						{t("pk.auto_pk")}
					</div>
				</ButtonComp>
				{
					isShowCreateArenaBtn &&
					<ButtonComp width={130} height={36} title='' callBack={async () => {
						setFinished(true)
						await getDeckListHandle(3, t("other.cfg2"), () => {
							setCreateArena(true)
						})
					}}>
						<div className=' text-[12px] text-white leading-[15px] font-bold flex justify-center items-center'>
							<svg className=' w-[14px] h-[16px] mr-1' width="17px" height="14px" viewBox="0 0 17 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
								<g id="页面-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
									<g id="卡牌战争1" transform="translate(-139.000000, -667.000000)" fillRule="nonzero">
										<g id="编组-7" transform="translate(101.000000, 656.000000)">
											<g id="编组" transform="translate(38.000000, 11.950000)">
												<path d="M3.32954922,10.6327317 L3.32954922,1.34738556 C3.32954922,1.24652588 3.34632391,1.14725966 3.35956107,1.05 L0.786129974,1.91648436 C0.189202142,2.11702338 -0.13807545,2.78639171 0.0558604793,3.40376625 L2.83104428,12.2346242 C2.9872657,12.7320176 3.43807116,13.05 3.91940201,13.05 C4.03551252,13.05 4.15384824,13.0314097 4.26990169,12.9924586 L5,12.743939 C4.0547977,12.5487115 3.32954922,11.6651712 3.32954922,10.6327317 Z" id="路径" fill="#FFFFFF"></path>
												<polygon id="路径" fill="#000000" points="6.99792895 0.00685355 6.99792895 0.09314645 7.00207105 0.09314645"></polygon>
												<path d="M4.99800316,9.37993939 L7.89592585,0.31315152 C7.92519298,0.221515161 7.96018239,0.110606071 8,0.05 L5.21199297,0.05 C4.55631389,0.05 4,0.600424268 4,1.26709092 L4,10.8024848 C4,11.4691515 4.55631389,12.05 5.21199297,12.05 L6.16386017,12.05 C5.17461926,11.5652121 4.65603672,10.4500606 4.99800316,9.37993939 Z" id="路径" fill="#FFFFFF"></path>
												<path d="M16.2056679,2.05236774 L10.3002116,0.106839083 C10.1832685,0.0682468132 10.0643705,0.05 9.94731241,0.05 C9.46229158,0.05 9.00866258,0.364043169 8.85124353,0.855307676 L6.05604942,9.5783859 C5.86062674,10.188342 6.19282805,10.8494242 6.79433208,11.0476323 L12.6997309,12.9931609 C12.816674,13.0316366 12.935572,13.05 13.0526301,13.05 C13.5376509,13.05 13.9912799,12.7358402 14.148699,12.2445757 L16.9439506,3.52149751 C17.1393733,2.91165796 16.8071719,2.25045919 16.2056679,2.05236774 Z M10.2277883,8.09616662 C10.0151602,8.13005602 9.81531828,7.98515969 9.78142889,7.77253161 C9.76774382,7.68666911 9.78315394,7.59869598 9.82520947,7.52259747 L9.85324416,7.47186934 C10.1028118,7.02028237 10.1261587,6.47779437 9.91631146,6.00643574 L9.90485554,5.98070346 C9.81327149,5.77498745 9.90579373,5.53397813 10.1115097,5.44239407 C10.1889829,5.40790328 10.2752829,5.39842783 10.3583941,5.41528698 C10.8422474,5.51343682 11.343,5.36136356 11.6905601,5.01072221 L11.7168064,4.98424324 C11.8663724,4.83335132 12.1099417,4.83227645 12.2608336,4.98184245 C12.3253605,5.04580235 12.3651672,5.13053663 12.3732022,5.22103542 L12.3773117,5.26732173 C12.4211803,5.76141787 12.7072984,6.20156963 13.1410503,6.44222442 C13.3406252,6.55295284 13.4126496,6.80450342 13.3019211,7.00407835 C13.2608232,7.07815253 13.197954,7.13780735 13.1218267,7.17496472 L13.1049517,7.18320133 C12.6458797,7.40727243 12.3199145,7.83536139 12.2260226,8.33749614 L12.2142888,8.40024851 C12.175075,8.6099638 11.9732782,8.74818262 11.7635629,8.70896888 C11.6771678,8.69281425 11.5988645,8.6476811 11.5415803,8.58102071 L11.5376149,8.57640621 C11.2139792,8.19979806 10.7181607,8.01800936 10.2277883,8.09616662 Z" id="形状" fill="#FFFFFF"></path>
											</g>
										</g>
									</g>
								</g>
							</svg>
							{t("pk.create_arena")}
						</div>
					</ButtonComp>}
			</div>



			{/* create Arena */}
			{
				isShowCreateArena && <CreateArena callback={async (type?: string) => {
					setCreateArena(false)
					if (type && isFirst) {
						await getCoinAnimation(width / 2, height / 2)
					}
				}}></CreateArena>
			}

			<PromptDialog
				lineBreak={true}
				title={t("other.attention")}
				dialog={isStart}
				setDialog={setStart}
				text={''}
			>
				<div>
					<p>⚔️ {t("pk.card_pk")}</p>
					<p className='mt-2'>🛠 {t("pk.setup")}</p>
					<p>💰 {t("pk.card_earn")}</p>
					<p className='mt-2'>📢 {t("pk.card_stay")}</p>
				</div>
				<ButtonComp mt={50} title={t("other.ok")} callBack={() => { setStart(false) }}></ButtonComp>
			</PromptDialog>
			<PromptDialog
				lineBreak={true}
				title={t("other.attention")}
				dialog={isCancel}
				isClose={true}
				setDialog={() => { setCancel(false) }}
				callback={async () => {
					setCancel(false)
					delBattleArenasHandle(currArenaId)
				}}
				text={'⚠️' + t("pk.removing")}
			></PromptDialog>

			<PromptDialog
				lineBreak={true}
				title={t("other.attention")}
				dialog={isCreate}
				setDialog={setCreate}
				text={promptText}
			></PromptDialog>

			<RulesDialog textArr={PK_RULES} title={t("pk.game_rules")} dialog={rulesDialog} setDialog={setRulesDialog} teleport={undefined}></RulesDialog>



			{
				Array.isArray(userInfo.card_rewards) && (userInfo.card_rewards.length > 0 || !!userInfo?.coins) && <>
					{(userInfo.card_rewards.length > 0 ? userInfo.card_rewards[0]?.is_card : !!userInfo?.coins) ?
						<DrawCardsDialog
							getCoinAnimation={getCoinAnimation}
							coins={userInfo?.coins}
							property={userInfo.card_rewards[0]?.property}
							power={userInfo.card_rewards[0].power}
							dialog={userInfo.card_rewards.length > 0 ? userInfo.card_rewards[0]?.is_card : userInfo?.coins}
							setDialog={closeDrawCard}
							description={userInfo.card_rewards.length > 0 ? userInfo.card_rewards[0]?.is_card : ''}
							cardLevel={userInfo.card_rewards.length > 0 ? userInfo.card_rewards[0]?.is_card : ''}
							imgUrl={userInfo.card_rewards.length > 0 ? userInfo.card_rewards[0]?.is_card : ''}
							setCardUrl={() => { }}
						></DrawCardsDialog> :
						<NFTDrawCardsDialog></NFTDrawCardsDialog>
					}
				</>
			}
			{
				isSoundPlay && <audio ref={AudioRef} src={coinsMusic} id="audio"></audio>
			}


			{selectCard && <PublicDialog width={'351'} closeOnClickOverlay={false} dialog={selectCard} setDialog={setSelectCard} content={selectCardDialog()}></PublicDialog>}

			{autoPKDialog && <PublicDialog width={'283'} closeOnClickOverlay={true} dialog={autoPKDialog} setDialog={setAutoPKDialog} content={autoPKContent()}></PublicDialog>}

			{
				coin_NSFW && <NsfwPay type={nsfwType} closeHandle={async (val) => {
					setCoin_NSFW(false)
					if (!val) {
						return;
					}

					try {
						const result = await postSetting(localStorage.getItem('userId'), { ...settings, ...starType, order_id: val })
						if (result.code == 0) {
							dispatch(changeSettings({ ...settings, ...starType }))
							setUserInfo()
						} else {

							setPromptText(t("other.neterror"))

							setCreate(true)
						}
						let ID = window.localStorage.getItem("userId") || "";

						const setting = await getSetting(ID)
						if (setting.code == 0) {
							dispatch(changeSettings(setting.data))
						} else {
							setPromptText(t("other.neterror"))

							setCreate(true)
						}
					} catch {
						setPromptText(t("other.neterror"))

						setCreate(true)
					}
				}
				}></NsfwPay>
			}
			{!guideTypeList.status && guideType && !guideTypeList.tasks.pkGuide && <BattleGuide></BattleGuide>}
		</div >
	)
}


export default Battle;